import React, {useState, useContext, useEffect} from 'react';
import { Card, Col, Row, Image } from "react-bootstrap";
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import {FaBook, FaDollarSign, FaGlobe, FaShoePrints, FaSortAmountUpAlt} from "react-icons/fa";
import {FaArrowRightFromBracket} from "react-icons/fa6";
import {editAssignment} from "../../http/bookAPI";
import {toast} from "react-toastify";
import CoverFitLikeProd from "../../helpers/CoverFitLikeProd";
import TripleSpinner from "../../helpers/TripleSpinner";

const CoverWithSpinner = ({
                              src,
                              fallbackSrc,
                              alt = "",
                              width = "auto",
                              height = "auto",
                              fetchPriority = "auto",
                              style = {},
                          }) => {
    const [loaded, setLoaded] = useState(false);
    const [err, setErr] = useState(false);

    const finalSrc = err ? fallbackSrc : src;

    return (
        <div

        >
            {!loaded && (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                    }}
                    aria-hidden="true"
                >
                    <TripleSpinner size={24} gapRatio={0.8} />
                </div>
            )}

            <img
                src={finalSrc}
                alt={alt}
                loading="lazy"
                decoding="async"
                fetchpriority={fetchPriority}
                onLoad={() => setLoaded(true)}
                onError={() => {
                    setErr(true);
                    setLoaded(true);
                }}
                style={{
                    maxWidth: 88,
                    maxHeight: 112,
                    width: "auto",
                    height: "auto",
                    opacity: loaded ? 1 : 0,
                    transition: "opacity 500ms ease-in",
                    backgroundColor: "white",
                    paddingLeft: 0,
                    paddingRight: 0,
                    paddingTop: 0,
                    paddingBottom: 0,
                    borderRadius: 4,
                }}
            />
        </div>
    );
};

const AssignLibraryItem4x = observer(({ bookitem, onOpen, alwaysOnTopBadge = null }) => {
    const { book } = useContext(Context);
    const currentTimeInMinutes = Math.floor(Date.now() / 60000);
    const date = new Date((currentTimeInMinutes + bookitem.turnaround_time) * 60 * 1000);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const daysToRead = Math.ceil(bookitem.turnaround_time / 60 / 24);
    const [bonus, setBonus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [columns, setColumns] = useState(12); // Начальное значение для 12 колонок

    const isFreePromo = [3, 32].includes(Number(bookitem?.assTypeId)) && Number(bookitem?.booksPriceId) === 1;
    const speedUpLevel = bookitem?.speed_up_level || 0;

    const coverSrc = bookitem.book.cover_file
        ? `${process.env.REACT_APP_API_URL}covers/${bookitem.book.cover_file}`
        : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;

    const fallbackCoverSrc = `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;


    const ModalOpen = async () => {

        await editAssignmentWhenOpenModal();
        onOpen(bookitem, bonus)
    };

    const editAssignmentWhenOpenModal = async () => {
        try {
            await editAssignment({
                id: bookitem?.id,
                clicks: bookitem?.clicks + 1,
            });
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An error occurred while calculating user assignments.";
            toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return null;
        } finally {
        }
    };

    useEffect(() => {
        setLoading(true); // Перед загрузкой данных включаем лоадер
        const handleResize = () => {
            const width = window.innerWidth;

            if (width >= 3300) setColumns(2);
            else if (width >= 2200) setColumns(3);
            else if (width >= 1680) setColumns(4);
            else if (width >= 1200) setColumns(6);
            else setColumns(12);
        };

        handleResize(); // Установить при первом рендере
        window.addEventListener('resize', handleResize);
        setLoading (false);
        return () => window.removeEventListener('resize', handleResize);

    }, []);

    useEffect(() => {
        let totalBonus = 0;
        const now = Date.now() / 60000; // Преобразуем текущую дату в минуты

        // Бонус по типу ассигмента
        if (book?.asstypes) {
            const assignmentType = book.asstypes.find(type => type.id === bookitem.assTypeId);
            if (assignmentType &&
                assignmentType.promotion_ass_price_bonus &&
                assignmentType.promotion_ass_price_bonus_start_date <= now &&
                assignmentType.promotion_ass_price_bonus_end_date >= now
            ) {
                totalBonus += assignmentType.promotion_ass_price_bonus;
            }
        }

        // Бонус по типу книги
        if (book?.types) {
            const bookType = book.types.find(type => type.id === bookitem.booksTypeId);
            if (bookType &&
                bookType.book_type_promotion_price_bonus &&
                bookType.book_type_promotion_price_bonus_start_date <= now &&
                bookType.book_type_promotion_price_bonus_end_date >= now
            ) {
                totalBonus += bookType.book_type_promotion_price_bonus;
            }
        }

        // Бонус по типу цены
        if (book?.prices) {
            const priceType = book.prices.find(price => price.id === bookitem.booksPriceId);
            if (priceType &&
                priceType.promotion_price_bonus &&
                priceType.promotion_price_bonus_start_date <= now &&
                priceType.promotion_price_bonus_end_date >= now
            ) {
                totalBonus += priceType.promotion_price_bonus;
            }
        }

        setBonus(totalBonus);
    }, [book]);

    return (
        <Col md={12} className="mt-0 d-flex justify-content-center align-items-center p-0">
            <div className="assignment-card" data-assignment-id={bookitem.id}></div>
            {/* === Десктопная карточка (оставлена без изменений) === */}
        <Card
            className="mt-0 mb-3 mx-2 "
            style={{
                borderRadius: '6px',
                boxShadow: isFreePromo
                    ? '0px 0px 12px 4px rgba(255, 215, 0, 0.5)'
                    : '0px 4px 12px rgba(0, 0, 0, 0.1)',
                border: (() => {
                    if (isFreePromo && speedUpLevel === 0) return '1px solid gold';
                    switch (speedUpLevel) {
                        case 1:
                            return '2px solid gray';
                        case 2:
                            return '2px solid green';
                        case 3:
                            return '2px solid gold';
                        case 5:
                            return '2px solid gray';
                        case 6:
                            return '2px solid green';
                        case 7:
                            return '2px solid gold';
                        default:
                            return '1px solid gray';
                    }
                })(),
                transition: 'transform 0.2s, box-shadow 0.2s',
                cursor: 'pointer',
                height: '140px',
                position: 'relative',
                animation: (() => {
                    if (isFreePromo || [4, 5, 6, 7].includes(speedUpLevel)) {
                        return 'promoPulse 1.5s ease-in-out infinite';
                    }
                    return 'none';
                })(),
            }}

            onClick={ModalOpen}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0px 6px 16px rgba(0, 0, 0, 0.2)';
                e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0px 2px 4px rgba(0, 0, 0, 0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
            }}
        >
            {alwaysOnTopBadge && (
                <span
                    className={`badge ${alwaysOnTopBadge.className} text-uppercase position-absolute`}
                    style={{
                        top: '6px',
                        left: '8px',
                        borderRadius: '4px',
                        padding: '3px 6px',
                        fontSize: '0.62rem',
                        fontWeight: 'bold',
                        lineHeight: '1',
                        whiteSpace: 'nowrap',
                        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.12)',
                        zIndex: 2,
                    }}
                >
                    {alwaysOnTopBadge.label}
                </span>
            )}
            <Card.Body style={{ paddingTop: '6px', paddingRight: '2px', paddingLeft: '4px', paddingBottom: '6px' }}>
                <Row className="mt-0 px-3 p-0">
                    <Col md={4} className="d-flex justify-content-center align-items-center position-relative"
                         style={{
                             borderRadius: "4px",
                             overflow: "hidden",
                             backgroundColor: "white",

                         }}
                    >
                        <CoverWithSpinner
                            src={coverSrc}
                            fallbackSrc={fallbackCoverSrc}
                            alt={bookitem.book.title}
                        />
                    </Col>

                    <Col md={8} className="flex-column justify-content-start small p-1 d-flex">
                        <p
                            className="fw-bold mb-0 px-1 text-muted"
                            style={{
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                WebkitLineClamp: 1,
                               fontSize: '0.9rem',
                                lineHeight: '1.1rem',
                            }}
                        >
                    {bookitem.book.title}
                </p>
                        <p
                            className="fst-italic mb-1 px-1 text-muted small"
                            style={{
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                WebkitLineClamp: 1,
                                fontSize: '0.8rem',
                                lineHeight: '1.1rem',
                            }}
                        >
                    {bookitem.book.subtitle || 'No Subtitle'}
                </p>
                        <Row className="text-muted px-1" style={{ fontSize: '0.85rem', lineHeight: '0.95rem', textWrap: 'nowrap' }}>
                            <p className="me-2 mb-0 mt-0 small text-muted">
                                <FaSortAmountUpAlt className="me-2"/>
                                <span>Due: {`${month}-${day}`}; Finish in {daysToRead} Day{daysToRead > 1 && 's'}</span>
                            </p>

                            <p className=" mb-0 mt-0 small text-muted">
                                <FaArrowRightFromBracket className="me-1 mb-0 mt-0 small text-muted"/>
                                <span className="text-muted small fst-italic"> {bookitem.book.total_words} W, </span>
                                <strong>Earn: <span className="text-success">{bookitem.assignment_price_reader}{bonus > 0 && '+' + bonus} Virt</span> </strong>
                            </p>
                            <p className=" mb-0 mt-0 small text-muted">
                                <FaBook className="me-2 mb-0 mt-0 small text-muted"/>
                                <strong>
                                {bookitem?.assTypeId === 1 && "Universal Assignment"}
                                {bookitem.assTypeId === 2 && "Kindle Unlimited"}
                                {bookitem.assTypeId === 3 && "Verified Purchase"}
                                {bookitem.assTypeId === 4 && "Verified Purchase Img"}
                                {bookitem.assTypeId === 5 && "Ver/Pur Search&Buy"}
                                {bookitem.assTypeId === 6 && "Ver/Pur Search&Buy Img"}
                                {bookitem.assTypeId === 7 && "Universal Audio"}
                                {bookitem.assTypeId === 8 && "Audible Promo Code"}
                                {bookitem.assTypeId === 9 && "Verified Kindle Unlimited"}
                                    {bookitem.assTypeId === 10 && "Paperback BuyOut"}
                                    {bookitem.assTypeId === 11 && "PB Search&BuyOut"}
                                    {bookitem.assTypeId === 12 && "Paperback VP + Images"}
                                    {bookitem.assTypeId === 13 && "Paperback VP + Video"}
                                    {bookitem.assTypeId === 14 && "Hardcover BuyOut"}
                                    {bookitem.assTypeId === 15 && "HC Search&BuyOut"}
                                    {bookitem.assTypeId === 16 && "Hardcover VP + Images"}
                                    {bookitem.assTypeId === 17 && "Hardcover VP + Video"}
                                    {bookitem.assTypeId === 18 && "PB Verified Purchase"}
                                    {bookitem.assTypeId === 19 && "PB Verified Search&Buy"}
                                    {bookitem.assTypeId === 20 && "HC Verified Purchase"}
                                    {bookitem.assTypeId === 21 && "HC Verified Search&Buy"}
                                    {bookitem.assTypeId === 22 && "Product BuyOut"}
                                    {bookitem.assTypeId === 23 && "Product Search&BuyOut"}
                                    {bookitem.assTypeId === 24 && "Product Verified Purchase"}
                                    {bookitem.assTypeId === 25 && "Product Verified + Img"}
                                    {bookitem.assTypeId === 26 && "Product Verified + Video"}
                                    {bookitem.assTypeId === 27 && "Product Verified Search&Buy"}
                                    {bookitem.assTypeId === 28 && "Make Helpful Internal"}
                                    {bookitem.assTypeId === 29 && "Write Report Internal"}
                                    {bookitem.assTypeId === 30 && "Make Helpful External"}
                                    {bookitem.assTypeId === 31 && "Write Report External"}
                                    {bookitem.assTypeId === 32 && "Set Stars Rating"}

                            </strong>
                            </p>
                            <p className=" mb-0 mt-0 small text-muted">
                                <FaGlobe className="me-2" />
                                <span>{bookitem?.book?.language}</span>,&nbsp;
                                (<span className="text-success">
                                                        {bookitem.booksTypeId === 1 && "Kindle"}
                                {bookitem.booksTypeId === 2 && "Paperback"}
                                {bookitem.booksTypeId === 3 && "Hardcover"}
                                {bookitem.booksTypeId === 4 && "Audio"}
                                {bookitem.booksTypeId === 5 && "Helpful"}
                                {bookitem.booksTypeId === 6 && "Report"}
                                {bookitem.booksTypeId === 7 && "Product"}
                                {bookitem.booksTypeId === 8 && "Product"}
                                {bookitem.booksTypeId === 9 && "Product"}
                                {bookitem.booksTypeId === 10 && "Product"}

                                                    </span>)
                            </p>



                            <p className="mb-0 mt-0 small text-muted">
                                <FaDollarSign className="me-2 mb-1 mt-0 small text-muted" />
                                {bookitem?.assTypeId === 1 && (
                                    <strong className="text-danger">Free File Download</strong>
                                )}
                                {bookitem?.assTypeId === 2 && (
                                    <strong className="text-danger">Requires Kindle Unlimited</strong>
                                )}
                                {bookitem?.assTypeId === 8 && (
                                    <strong className="text-danger">Free Audible Promo Code</strong>
                                )}
                                {bookitem?.assTypeId === 9 && (
                                    <strong className="text-danger">Requires Paid KU Subscr...</strong>
                                )}
                                {[10,11,12,13,14,15,16,17,18,19,20,21].includes(bookitem?.assTypeId) && (
                                    <strong className="text-danger">Buy & Full Refund: ${bookitem?.book_cost_compensation}</strong>
                                )}
                                {[22,23,24,25,26,27].includes(bookitem?.assTypeId) && (
                                    <strong className="text-danger">Buy and Get Refund: ${bookitem?.book_cost_compensation}</strong>
                                )}
                                {[3, 4, 5, 6, 32].includes(bookitem?.assTypeId) && (
                                    bookitem?.assignment_price_amz === "Free Promotion" ? (
                                        <strong className="text-danger">HOT!!! $0.00 Free Promo</strong>
                                    ) : (
                                        <strong className="text-danger">
                                            Requires Purchase: {bookitem.assignment_price_amz}
                                        </strong>
                                    )
                                )}
                                {[28,29,30,31].includes(bookitem?.assTypeId) && (
                                    <strong className="text-danger">Free Tap (Existing Review)</strong>
                                )}
                            </p>
                        </Row>
                    </Col>
                </Row>
            </Card.Body>

        </Card>
        </Col>
    );
});

export default AssignLibraryItem4x;
